<template>
	<v-dialog
		v-model="showDialog"
		max-width="800"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">部品調達依頼詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-title style="color: white" @click="closeDialog()"
					><v-icon>mdi-close</v-icon></v-toolbar-title
				>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-row no-gutters justify="end">
					<v-btn class="mr-2" color="primary" dense @click="openStockPage(requirement)">
						在庫表を確認する</v-btn
					>
					<v-btn
						class="mr-2"
						color="secondary"
						dense
						@click="openComponentStockAllocationDialog(requirement)"
						:disabled="disabledBtn() || orderStatus(requirement) == 'draft'"
						v-if="authority_flag"
					>
						在庫から引き当てる</v-btn
					>
					<v-btn
						class="mr-2"
						color="secondary"
						dense
						@click="openOrderPage(requirement)"
						:disabled="refused_flag || disabledBtn() || orderStatus(requirement) == 'draft'"
						v-if="authority_flag"
					>
						部品を注文する</v-btn
					>
					<v-btn
						v-if="!refused_flag && !requirement.answer && authority_flag"
						class="mr-2"
						color="red"
						dense
						dark
						@click="openRefuseDialog()"
					>
						依頼を差戻す
					</v-btn>
					<v-btn
						v-else-if="requirementStatus(requirement) == '差戻し' && authority_flag"
						class="mr-2"
						disabled
						dense
					>
						差戻し済み
					</v-btn>
					<v-btn
						v-else-if="
							requirementStatus(requirement) == '回答済み' &&
							authority_flag &&
							requirement.answer.status_id != 'other_draft' &&
							orderStatus(requirement) != 'draft'
						"
						class="mr-2"
						disabled
						dense
					>
						回答済み
					</v-btn>
					<v-btn
						@click="openOrderEditPage(requirement)"
						v-else-if="requirement.answer && authority_flag && orderStatus(requirement) == 'draft'"
						class="mr-2"
						dense
					>
						発注下書き
					</v-btn>
				</v-row>

				<v-sheet elevation="0" class="mt-4">
					<h3 class="mt-5 font-weight-bold">依頼情報</h3>
					<table width="100%" class="show-dialog-table mt-1">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">注文状況</th>
								<td
									width="70%"
									v-if="requirement.answer && requirement.answer.status_id != 'other_draft'"
								>
									{{ requirementStatus(requirement) }}
								</td>
								<td width="70%" v-else>未処理</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">依頼発行日</th>
								<td width="70%">{{ requirement.requirement_date | dateFormatter }}</td>
							</tr>
							<tr v-if="requirement && requirement.from_department">
								<th width="30%" class="font-weight-bold">依頼元部門</th>
								<td width="70%">{{ requirement.from_department.name }}</td>
							</tr>
							<tr v-if="requirement && requirement.user">
								<th width="30%" class="font-weight-bold">依頼者</th>
								<td width="70%">{{ requirement.user.full_name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">依頼確認者</th>
								<td
									width="70%"
									v-if="requirement.confirmations && requirement.confirmations.length > 0"
								>
									{{
										requirement.confirmations && requirement.confirmations[0].user
											? requirement.confirmations[0].user.full_name
											: ""
									}}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">依頼承認者</th>
								<td width="70%" v-if="requirement.approvals && requirement.approvals.length > 0">
									{{
										requirement.approvals && requirement.approvals[0].user
											? requirement.approvals[0].user.full_name
											: ""
									}}
								</td>
							</tr>
							<tr v-if="requirement.responder">
								<th width="30%" class="font-weight-bold">担当者</th>
								<td width="70%">{{ requirement.responder.full_name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">部品調達理由</th>
								<td width="70%">{{ refuseText(requirement) }}</td>
							</tr>
						</tbody>
					</table>
					<h3 class="mt-5 font-weight-bold">調達部品情報</h3>
					<table width="100%" class="show-dialog-table mt-1">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">部品名</th>
								<td width="70%">{{ componentName(requirement) }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">製造番号</th>
								<td
									width="70%"
									@click="openOrderedProductShowDialog()"
									class="clickable font-weight-bold text-decoration-underline"
									v-if="requirement.ordered_product"
								>
									{{ requirement.ordered_product.product_number }}
								</td>
								<td width="70%" v-else>対象製番なし</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">希望納期</th>
								<td width="70%">{{ expectedReceivingDate(requirement) | dateFormatter }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">希望個数</th>
								<td width="70%" :style="{ color: !disabledBtn() ? 'red' : '' }">
									{{ quantity(requirement) }}
								</td>
							</tr>
							<tr v-if="shippingQuantity(requirement)">
								<th width="30%" class="font-weight-bold">在庫引き当て個数</th>
								<td width="70%">{{ shippingQuantity(requirement) }}</td>
							</tr>
							<tr v-if="orderQuantity(requirement)">
								<th width="30%" class="font-weight-bold">部品注文個数</th>
								<td width="70%">{{ orderQuantity(requirement) }}</td>
							</tr>
							<tr v-if="orderNumber(requirement)">
								<th width="30%" class="font-weight-bold">注文番号</th>
								<td width="70%">{{ orderNumber(requirement) }}</td>
							</tr>
						</tbody>
					</table>
					<div
						v-for="(file, index) in requirement.return_all_attached_file_infos"
						:key="`file-${file.id}`"
					>
						<h3 v-if="!file.destroy_flag" class="font-weight-bold mt-5">
							{{ `添付ファイル #${index + 1}` }}
						</h3>
						<v-btn
							color="secondary"
							dense
							dark
							outlined
							v-if="!file.destroy_flag"
							class="mt-2"
							:href="file.url"
							>{{ file.name }}</v-btn
						><v-icon v-if="!file.destroy_flag" class="mt-2" @click="deleteFile(index, file.id)"
							>mdi-close</v-icon
						>
					</div>
				</v-sheet>
				<OrderedProductSingleDialog
					v-if="orderedProductShow"
					:ordered_product="requirement.ordered_product"
					@close="orderedProductShow = false"
				/>
				<RefuseMessageDialog
					:dialog.sync="refuseDialog"
					:requirement="requirement"
					:requirements="requirements"
					@submitMessage="submitMessage"
				/>
				<ComponentStockAllocationDialog
					:dialog.sync="ComponentStockAllocationDialog"
					:quantity="NumberOfRequiredComponents()"
					@withdraw-stocks="withdrawStocks"
				/>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import moment from "moment"
import "moment/locale/ja"
import OrderedProductSingleDialog from "../../shared/OrderedProductSingleDialog.vue"
import RefuseMessageDialog from "./RefuseMessageDialog.vue"
import ComponentStockAllocationDialog from "./ComponentStockAllocationDialog.vue"

export default {
	components: {
		OrderedProductSingleDialog,
		RefuseMessageDialog,
		ComponentStockAllocationDialog,
	},
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},

		requirement_id: {
			type: null,
			required: false,
		},

		requirements: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	data() {
		return {
			authority_flag: false,
			requirement: {},
			orderedProductShow: false,
			refuseDialog: false,
			ComponentStockAllocationDialog: false,
			refused_flag: false,
		}
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月DD日(dd)")
		},
	},

	methods: {
		closeDialog() {
			this.showDialog = false
			this.refused_flag = false
		},
		NumberOfRequiredComponents() {
			const quantity = this.quantity(this.requirement) || 0
			const orderQuantity = this.orderQuantity(this.requirement) || 0
			const shippingQuantity = this.shippingQuantity(this.requirement) || 0
			return quantity - orderQuantity - shippingQuantity
		},
		disabledBtn() {
			return (
				this.quantity(this.requirement) ==
					this.shippingQuantity(this.requirement) + this.orderQuantity(this.requirement) ||
				this.requirementStatus(this.requirement) == "差戻し"
			)
		},
		fetchRequirementInfo(requirement_id) {
			const headers = authenticate.setHeader()

			axios
				.get(
					`/erp/v1/component_procurement_requirements/component_procurement_requirements/${requirement_id}`,
					{
						headers,
					}
				)
				.then((res) => {
					this.requirement = res.data.requirement
					this.component_procurement_requirements =
						res.data.requirement.component_procurement_requirements
					// TODO authorityはindexで取得してpropsで渡す
					this.authority_flag = res.data.authority_flag
					if (this.requirement.ordered_product) {
						this.ordered_product_id = this.requirement.ordered_product.id
						this.requirement.ordered_product.order_components.forEach((order_component) => {
							const value = this.requirement.requirement_values.find((value) => {
								return value.requirement_column.name == "製品部品"
							})
							if (value.value.name == order_component.component.name) {
								this.remarks = order_component.remarks
								this.unit_price = order_component.unit_price
								this.component_id = order_component.component.id
								this.product_number = this.requirement.ordered_product.product_number
							}
						})
					} else {
						this.component_id = this.componentId(this.requirement)
					}
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openOrderedProductShowDialog() {
			this.orderedProductShow = true
		},

		openOrderPage() {
			this.$router.push({
				path: `/component_procurement_requirement_order/${this.requirement.id}`,
				query: { requirement_id: this.requirement.id },
			})
		},

		orderDataId(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "注文データ"
				})
			return value && value.value && value.value.id
		},

		orderStatus(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "注文データ"
				})
			return value && value.value_target && value.value_target.status_type
		},

		orderNumber(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "注文データ"
				})
			return value && value.value_target && value.value_target.order_number
		},

		openOrderEditPage(requirement) {
			const orderDataId = this.orderDataId(requirement)
			this.$router.push({
				path: `/order_data/${orderDataId}/edit`,
				query: { order_data_id: orderDataId },
			})
		},

		deleteFile(index, file_id) {
			const headers = authenticate.setHeader()

			axios
				.delete(`/erp/v1/component_procurement_requirements/files/${file_id}`, {
					headers,
				})
				.then((res) => {
					this.requirement.return_all_attached_file_infos = res.data.return_all_attached_file_infos
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openRefuseDialog() {
			this.refuseDialog = true
		},
		reload(requirement) {
			const requirement_id = requirement.id
			this.fetchRequirementInfo(requirement_id)
			this.$emit("reload", requirement)
		},
		componentName(requirement) {
			const value =
				requirement.requirement_values &&
				requirement.requirement_values.find((value) => {
					return (
						value.requirement_column.name == "製品部品" || value.requirement_column.name == "部品"
					)
				})
			return value && value.value && value.value.name
		},
		componentId(requirement) {
			const value =
				requirement.requirement_values &&
				requirement.requirement_values.find((value) => {
					return (
						value.requirement_column.name == "製品部品" || value.requirement_column.name == "部品"
					)
				})
			return value && value.value && value.value.id
		},
		expectedReceivingDate(requirement) {
			const value =
				requirement.requirement_values &&
				requirement.requirement_values.find((value) => {
					return value.requirement_column.name == "納期希望日"
				})
			return value && value.value
		},
		quantity(requirement) {
			const value =
				requirement.requirement_values &&
				requirement.requirement_values.find((value) => {
					return value.requirement_column.name == "数量"
				})
			return value && value.value
		},
		shippingQuantity(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "在庫引当数量"
				})
			return value ? value.value : 0
		},
		orderQuantity(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "部品注文数量"
				})
			return value ? value.value : 0
		},

		refuseText(requirement) {
			const value =
				requirement.requirement_values &&
				requirement.requirement_values.find((value) => {
					return value.requirement_column.name == "部品調達依頼理由"
				})
			return value && value.value
		},
		requirementStatus(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "依頼状況"
				})
			return value ? value.value : ""
		},
		openStockPage(requirement) {
			const query = { name_cont: this.componentName(requirement) }
			const url = this.$router.resolve({ name: "stocks", query }).href
			window.open(url, "_blank")
		},
		openComponentStockAllocationDialog() {
			this.ComponentStockAllocationDialog = true
		},

		// todo 在庫を複数回引き当てた場合と注文した場合の処理を考慮する
		withdrawStocks(params) {
			if (this.requirement.ordered_product) {
				params.ordered_product_id = this.requirement.ordered_product.id
				params.unit_price = this.unit_price
				params.remarks = this.remarks
				params.product_number = this.product_number
			}
			params.component_id = this.component_id
			params.requirement_id = this.requirement_id
			const headers = authenticate.setHeader()

			axios
				.post(
					"/erp/v1/component_procurement_requirements/component_procurement_shippings",
					params,
					{ headers }
				)
				.then((res) => {
					this.requirement = res.data.requirement
					this.$store.dispatch("setFlash", {
						text: "在庫表に部品出庫数を入力しました。",
						type: "notice",
					})
					this.ComponentStockAllocationDialog = false
					this.$emit("reload", this.requirement)
					this.fetchRequirementInfo(this.requirement.id)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		submitMessage(requirement_id, params) {
			const headers = authenticate.setHeader()

			if (this.requirement.ordered_product) {
				params.ordered_product_id = this.requirement.ordered_product.id
				params.unit_price = this.unit_price
				params.remarks = this.remarks
				params.product_number = this.product_number
			}

			axios
				.put(
					`/erp/v1/component_procurement_requirements/component_procurement_requirements/${requirement_id}`,
					params,
					{ headers }
				)
				.then((res) => {
					this.requirement = res.data.requirement
					this.refused_flag = res.data.refused_flag
					this.$store.dispatch("setFlash", {
						text: "差戻しました",
						type: "notice",
					})
					this.fetchRequirementInfo(requirement_id)
					this.$emit("reload", this.requirement)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		requirement_id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchRequirementInfo(newVal)
		},
	},
}
</script>

<style scoped lang="scss">
@media (max-width: 700px) {
	.v-btn {
		display: block !important;
		margin-bottom: 10px;
		width: 40%;
		text-align: center;
	}
}
</style>
